var map = {
	"./fondo.jpg": 78,
	"./habilidades/angular.png": 44,
	"./habilidades/css.png": 45,
	"./habilidades/html.png": 46,
	"./habilidades/javascript.png": 47,
	"./habilidades/laravel.png": 48,
	"./habilidades/php.png": 49,
	"./habilidades/react.png": 50,
	"./habilidades/vue.png": 51,
	"./informacion/correo.png": 52,
	"./informacion/cv.png": 53,
	"./informacion/github.png": 54,
	"./informacion/linkedin.png": 55,
	"./photo.jpeg": 23,
	"./portafolio/encuestas/encuestas.PNG": 79,
	"./portafolio/historia_clinica/paciente.PNG": 80,
	"./portafolio/historia_clinica/reporte.PNG": 81,
	"./portafolio/logistico/kardex.PNG": 82,
	"./portafolio/logistico/producto.PNG": 83,
	"./portafolio/logistico/salida.PNG": 84,
	"./portafolio/pedidos/detalle.PNG": 85,
	"./portafolio/pedidos/pedido.PNG": 86,
	"./portafolio/proyectos/listado.PNG": 87,
	"./portafolio/proyectos/tarea.PNG": 88,
	"./portafolio/tarjetas/editar.PNG": 89,
	"./portafolio/tarjetas/tar1.PNG": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;